import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common'
@Pipe({ name: 'hourMinConvertion' })


export class TimeConvertionPipe implements PipeTransform {

    transform(min: number): string {
        var hours: any;
        if (min != 0)
            hours = ((Math.floor(min / 60)) < 10 ? ("0" + (Math.floor(min / 60))) : Math.floor(min / 60)) + " h " +
                (Number(((min % 60).toFixed(0))) < 10 ? ("0" + (min % 60).toFixed(0)) : (min % 60).toFixed(0)) + " m"
        else
            hours = "00 h 00 m"
        return hours;
    }
}